import { registerPlugin } from '@capacitor/core';
const CapacitorShareTarget = registerPlugin('CapacitorShareTarget', {
    web: () => import('./web').then((m) => new m.CapacitorShareTargetWeb()),
});
export * from './definitions';
export { CapacitorShareTarget };
//# sourceMappingURL=index.js.map